import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import EmailSenderPanel from "./EmailSenderPanel";
import { ActivityButton, InfoTip } from "./VaultUi";

/**
 * Settings > Configs: one section per config kind (its title fills the Purpose column). Secrets live
 * in the Vault; a config kind only selects Vault items, tests them and stores non-secret settings.
 * Add a kind by adding an entry here; `showLog` asks it to show its activity log.
 */
const CONFIG_KINDS = [
  {
    key: "email",
    render: ({ onManageVault, showLog }) => (
      <EmailSenderPanel
        basePath="/client/email-accounts"
        title="Email sending"
        onManage={onManageVault}
        showLog={showLog}
      />
    ),
  },
];

const INFO =
  "Settings your company's apps use. Email sending: the account your company's emails go out from — " +
  "pick one of the email accounts stored in the Vault and test the connection. Login details are added " +
  "and edited in the Vault and are never shown here.";

function ConfigsPanel({ onManageVault }) {
  const [showLog, setShowLog] = useState(false);
  return (
    <div className="configs vault">
      <div className="configs-head">
        <div className="configs-head__title">
          <h2>App Configs</h2>
          <InfoTip text={INFO} label="About App Configs" />
        </div>
        <div className="configs-head__actions">
          <ActivityButton open={showLog} onToggle={() => setShowLog((v) => !v)} />
          {onManageVault ? (
            <button type="button" className="vault-btn" onClick={() => onManageVault()}>
              Go to Vault <FaArrowRight />
            </button>
          ) : null}
        </div>
      </div>
      {CONFIG_KINDS.map((kind) => (
        <React.Fragment key={kind.key}>{kind.render({ onManageVault, showLog })}</React.Fragment>
      ))}
    </div>
  );
}

export default ConfigsPanel;
